<app-logo-header></app-logo-header>
<div class="section">
  <p class="h404">404</p>
  <h3>Page Not Found</h3>
</div>

<app-footer></app-footer>
